// EDEN · session state (the signed-in user, role-aware).

import { api } from "./api";

export interface Me {
  id: string;
  name: string;
  auth_role: "teacher" | "lead";
}

let current: Me | null = null;
let resolved = false;

export const me = (): Me | null => current;
export const setMe = (m: Me | null, announce = true): void => {
  const changed = current?.id !== m?.id;
  current = m;
  resolved = true;
  // PDF work and private previews must stop when this browser switches accounts.
  // Announce only a revision, never a user id, cookie, role or book contents.
  if (changed && announce && typeof window !== "undefined") {
    const revision = { type: "eden-session-changed", signedIn: !!m };
    window.dispatchEvent(new CustomEvent("eden:session-changed", { detail: revision }));
    if (typeof BroadcastChannel !== "undefined") {
      const channel = new BroadcastChannel("eden-session-revision");
      channel.postMessage(revision); channel.close();
    }
  }
};

/** Re-resolve the user from the session cookie (null if signed out). */
export async function refreshMe(): Promise<Me | null> {
  // Opening another tab resolves its existing cookie; it is not a new sign-in
  // and must not cancel a book already being read in the first tab.
  const announce = resolved;
  try {
    setMe(await api<Me>("/api/me"), announce);
  } catch {
    setMe(null, announce);
  }
  return current;
}
